<template>
  <donut-chart08-template
    :board-ids="[244]"
    :data-type="dataType"
    field-code="facility"
    :graph-id="65"
    title="(시설물) 중대재해 발생 현황"
    unit="건"/>
</template>

<script>
/* eslint-disable brace-style */
import DonutChart08Template from "@/views/graph/DonutChart08Template.vue";

export default {
  name: 'DonutChart65',
  components: {DonutChart08Template},
  props: {
    dataType: 'detail' | 'field' | 'company' | 'project',
  },
}
</script>

<style scoped>

</style>
